export function calculateVolumeWeight(length, width, height, unit, quantity) {
    const l = parseFloat(length) || 0;
    const w = parseFloat(width) || 0;
    const h = parseFloat(height) || 0;
    const q = parseFloat(quantity) || 1;
    const volume = l * w * h;
    const volWeightPerPiece = volume / 6000;
    return q * volWeightPerPiece; // return a number (kg)
}
